'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@workspace/ui/components/dialog';
import type { Currency } from '@workspace/ui/types';
import Image from 'next/image';
import { useState } from 'react';

interface AddNewCurrencyDialogProps {
  children: React.ReactNode;
  allCurrencies: Currency[];
  currentCurrency?: Currency;
  onCurrencySelect: (currencyCode: string) => Promise<void>;
  isLoading?: boolean;
  title?: string;
  description?: string;
  submitText?: string;
  loadingText?: string;
}

export function AddNewCurrencyDialog({
  children,
  allCurrencies,
  currentCurrency,
  onCurrencySelect,
  isLoading = false,
  title = 'Add new currency',
  description = 'Select a currency to add a new wallet. You’ll be able to hold and manage funds in that currency.',
  submitText = 'Add',
  loadingText = 'Adding',
}: AddNewCurrencyDialogProps) {
  const [open, setOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<string | null>(null);

  // Filter out the current currency
  const availableCurrencies = allCurrencies.filter((c) => c.code !== currentCurrency?.code);

  const handleAdd = async () => {
    if (!selectedCurrency) return;

    await onCurrencySelect(selectedCurrency);
    setOpen(false);
    setSelectedCurrency(null);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    if (!newOpen) {
      setSelectedCurrency(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div
          className="border-grey-300 flex max-h-[400px] flex-col items-start gap-6 self-stretch overflow-y-auto rounded-[18px] border p-4"
          style={{ scrollbarGutter: 'stable' }}
        >
          {availableCurrencies.map((currency) => (
            <button
              key={currency.id}
              type="button"
              onClick={() => setSelectedCurrency(currency.code)}
              className={`flex w-full cursor-pointer items-center gap-3 rounded-2xl p-3 text-left text-base transition-all ${
                selectedCurrency === currency.code
                  ? 'bg-grey-25 dark:bg-grey-900 font-medium text-neutral-200 dark:text-neutral-100'
                  : 'hover:bg-grey-25 dark:hover:bg-grey-900 text-neutral-200 dark:text-neutral-100'
              }`}
            >
              <Image
                src={`https://i.nativeteams.com/assets/app/flags_code/${currency.flag_code}.svg`}
                alt={`${currency.name} Flag`}
                className="h-8 w-8 rounded-full"
                width={32}
                height={32}
              />
              <span>
                {currency.name} ({currency.code})
              </span>
            </button>
          ))}
        </div>

        <DialogFooter>
          <Button
            onClick={handleAdd}
            disabled={!selectedCurrency}
            isLoading={isLoading}
            loadingText={loadingText}
            variant="primary"
            size="base"
            className="w-full"
          >
            {submitText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
